"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeveloperStatusMessages = void 0;
const FaceTecSDK_1 = require("./../../../core-sdk/FaceTecSDK.js/FaceTecSDK");
// Helper class to log and or display SampleApp messages.
// This classes sole purpose is to help developers learn about the FaceTecSDK response statuses.
class DeveloperStatusMessages {
}
exports.DeveloperStatusMessages = DeveloperStatusMessages;
_a = DeveloperStatusMessages;
DeveloperStatusMessages.LOG_PREFIX = "FaceTec SampleApp:";
// Display the message on the screen for the user
DeveloperStatusMessages.displayMessage = (message) => {
    if (document.getElementById("status") !== null) {
        document.getElementById("status").innerHTML = message !== null && message !== void 0 ? message : "";
    }
};
// Log the message to the console for the developer. Prefix with FaceTec SampleApp: so the messages can be filtered
DeveloperStatusMessages.logMessage = (message) => {
    console.log(`${_a.LOG_PREFIX} ${message}`);
};
// Log the message and display on screen for the user
DeveloperStatusMessages.logAndDisplayMessage = (message) => {
    _a.displayMessage(message);
    _a.logMessage(message);
};
// Process the FaceTecSDK.getStatus result
DeveloperStatusMessages.logInitializeResult = () => {
    // User message to display
    const displayMessage = FaceTecSDK_1.FaceTecSDK.getFriendlyDescriptionForFaceTecSDKStatus(FaceTecSDK_1.FaceTecSDK.getStatus());
    // Message to log for developer
    const logMessage = `FaceTecSDK.getStatus(): ${FaceTecSDK_1.FaceTecSDK.getStatus()} "${displayMessage}"`;
    _a.displayMessage(displayMessage !== null && displayMessage !== void 0 ? displayMessage : "No Messages");
    _a.logMessage(logMessage);
};
// Process onComplete results from FaceTecSessionResult or FaceTecIDScanResult
DeveloperStatusMessages.logScanOncompleteResult = (sessionResult, idScanResult) => {
    // User message to display
    let displayMessage = "See logs for details";
    // Message to log for developer
    let logMessage = "Unable to parse status message";
    // Check for an idScanResult
    if (idScanResult != null && idScanResult.status != null) {
        logMessage = `FaceTecIDScanResult.status: ${idScanResult.status} (${FaceTecSDK_1.FaceTecSDK.getFriendlyDescriptionForFaceTecIDScanStatus(idScanResult.status)})`;
        // Add additional logging for the case where the developer cancelled the session before the idScan was processed by the server
        // The developer should be handling this appropriately in the processor
        if (idScanResult.status === FaceTecSDK_1.FaceTecSDK.FaceTecIDScanStatus.Success && idScanResult.isCompletelyDone === false) {
            logMessage += `\n${_a.LOG_PREFIX} Developer called idScanResultCallback.cancel before the idScan was processed by the server.`;
        }
    }
    // Else show the sessionResult
    else if (sessionResult != null && sessionResult.status != null) {
        // Special case message for user when the device is locked out
        if (sessionResult.status === FaceTecSDK_1.FaceTecSDK.FaceTecSessionStatus.LockedOut) {
            displayMessage = "This device is locked out of Facial Recognition.";
        }
        logMessage = `FaceTecSessionResult.status: ${sessionResult.status} - "${FaceTecSDK_1.FaceTecSDK.getFriendlyDescriptionForFaceTecSessionStatus(sessionResult.status)}"`;
        // Add additional logging for the case where the developer cancelled the session before the idScan was processed by the server
        // The developer should be handling this appropriately in the processor
        if (sessionResult.status === FaceTecSDK_1.FaceTecSDK.FaceTecSessionStatus.SessionCompletedSuccessfully && sessionResult.isCompletelyDone === false) {
            logMessage += `\n${_a.LOG_PREFIX} Developer called FaceScanResultCallback.cancel before the faceScan was processed by the server.`;
        }
    }
    _a.displayMessage(displayMessage);
    _a.logMessage(logMessage);
};
